import Decimal from 'decimal.js';
import Numeric from '@/core/types/Numeric';
import Title_ru_RU_Class from '@/core/misc/decorators/Title_ru_RU_Class';

/**
 * Плотность (масса, делённая на объём). Точность — 2 знака.
 *
 * Единица — КИЛОГРАММЫ НА м³.
 *
 * Зеркальный бекенд: core/types/Density.php на BcMath\Number.
 */
@Title_ru_RU_Class('Плотность')
class Density extends Numeric {
    static readonly SCALE = 2;

    static fromServer(value: string): Density {
        return new Density(value);
    }

    /** Результат вычисления — уже посчитанный Decimal. */
    static fromOperation(value: Decimal): Density {
        return new Density(value);
    }
}

export default Density;